import { Vue, Component, Prop, px } from '@/utils';

@Component({
  name: 'page',
})
export class Page extends Vue {
  @Prop({default: 46, type: [String, Number]})
  public headerHeight: string;
  @Prop({default: 50, type: [String, Number]})
  public footerHeight: string;
  @Prop({default: '#fff'})
  public backgroundColor: string;

  public get contentStyles() {
    const result = {
      'background-color': this.backgroundColor,
    };
    if (this.$slots.header) {
      result['padding-top'] = px(this.headerHeight);
    }
    if (this.$slots.footer) {
      result['padding-bottom'] = px(this.footerHeight);
    }
    return result;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/page.ts